import React, { useEffect, useState } from 'react';
import Common from "../Common";
import Modal from "../../../component/Global/Modal";
import Listing from "./InventoryAlertPopup/Listing";
import CartRepository from "../../../repository/CartRepository";
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const InventoryAlertPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [CART_DATA_HERE, set_CART_DATA_HERE] = useState([]);
    const [backOrderItemCount, set_backOrderItemCount] = useState(0);
    const [obSoluteBackOrderItemCount, set_obSoluteBackOrderItemCount] = useState(0);
    const [{ CART_DATA, CART_PRODUCT_DATA, CART_PRODUCT_INVENTORY_DATA }, { }, { },] = useCartStore();
    const [{ InventoryAlertPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [__check] = useAxiosIndicatorCheck();
    const getCartProductInventoryQuantityByERPPartNumber = (ERPPartNumber) => {
        return new Common().getCartProductInventoryQuantityByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    };
    const getCartProductInventoryLeadTimeByERPPartNumber = (ERPPartNumber) => {
        return new Common().getCartProductInventoryLeadTimeByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    };

    useEffect(() => {
        if (InventoryAlertPopup) {
            set_CART_DATA_HERE(FILTER_CART_DATA_HERE())
            SetStatus(true)
        }
    }, [InventoryAlertPopup]);

    const onHide = (action = true) => {
        if (action === false && props?.data?.from === "onload") {
            setTimeout(() => {
                System.alert('Error: To proceed, please update the quantity or remove the highlighted insufficient inventory items from your cart.', 'danger');
            }, 500);
        }
        SetStatus(false)
    };

    const updateBackOrderQuantityToCartServer = async () => {
        let d = [];
        let c = FILTER_CART_DATA_HERE();
        if (c && c.length > 0) {
            c.map((v, i) => {
                if ((CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) === false) {
                    let b_q = v.quantity - new CartRepository().getInventoryQuantity(v.ERPPartNumber);
                    let q = v.quantity - b_q;
                    if (q < 1) {
                        q = 0;
                    }
                    if (b_q < 1) {
                        b_q = 0;
                    }
                    d.push({
                        "cartDetailId": v.cartDetailId,
                        "quantity": q,
                        "backOrderedQuantity": b_q
                    });
                }
            })
        }
        if (d.length) {
            await new CartRepository().updateBackOrderQuantityToCartServer(d);
        }
        onHide();
    };

    const FILTER_CART_DATA_HERE = () => {
        let d = [];
        let obsoleteCount = 0;
        let normalBackorderCount = 0;
        if (CART_DATA && CART_DATA.length > 0) {
            if (props?.data?.CURRENT_CART_DATA_SINGLE?.ERPPartNumber) {
                CART_DATA.map((v) => {
                    if (v.ERPPartNumber && props.data.CURRENT_CART_DATA_SINGLE.ERPPartNumber === v.ERPPartNumber) {
                        if (new CartRepository().getUnadjustedQuantity(v.ERPPartNumber)) {
                            if ((CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) === false) {
                                normalBackorderCount++;
                            }
                            if (CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) {
                                obsoleteCount++;
                            }
                        }
                        d.push(v);
                    }
                })
            } else {
                CART_DATA.map((v) => {
                    if (new CartRepository().getUnadjustedQuantity(v.ERPPartNumber)) {
                        // if ((CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true || CART_PRODUCT_DATA[v.ERPPartNumber].EndOfLifeOFlag === true) === false) {
                        //     normalBackorderCount++;
                        // }
                        if (CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === false) {
                            normalBackorderCount++;
                        }
                        if (CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) {
                            obsoleteCount++;
                        }
                    }
                    d.push(v);
                })
            }
        }
        set_backOrderItemCount(normalBackorderCount);
        set_obSoluteBackOrderItemCount(obsoleteCount);
        return d;
    };
    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-680">
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => { onHide() }}>×
                        </button>
                        <div className="modal-header justify-content-center mt-0">
                            <h3 className="pcn-modal-heading">Inventory Alert</h3>
                        </div>
                        <div className="m-4 mt-0">
                            {backOrderItemCount > 0 &&
                                <div className="justify-content-start">
                                    We currently do not have sufficient inventory for the following items in your cart.
                                    <br />Would you like to place backorder for these items?
                                </div>
                            }
                            {(obSoluteBackOrderItemCount > 0) &&
                                <div className="justify-content-start">
                                    Please Remove Obsolete Products or match the available Stock.
                                </div>
                            }
                        </div>
                        <div className="modal-body">
                            <div className="inventory-table">
                                <Listing CART_DATA={CART_DATA_HERE} CART_PRODUCT_DATA={CART_PRODUCT_DATA}
                                    getCartProductInventoryQuantityByERPPartNumber={(ERPPartNumber) => {
                                        return getCartProductInventoryQuantityByERPPartNumber(ERPPartNumber)
                                    }}
                                    getCartProductInventoryLeadTimeByERPPartNumber={(ERPPartNumber) => {
                                        return getCartProductInventoryLeadTimeByERPPartNumber(ERPPartNumber)
                                    }} />
                            </div>
                        </div>
                        {/* Modal footer */}
                        <div className="modal-footer justify-content-center">
                            <div className="modal-footer-actions">
                                <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                    disabled={__check(['CART_API_CALL', 'CART_OPERATION_API_CALL','VIEW_CART_API_CALL']).status}
                                    data-bs-toggle="modal" data-bs-target="#InventoryModal"
                                    onClick={() => { onHide(false) }}>
                                    {backOrderItemCount > 0 ? "No" : "Close"}
                                </button>
                                {backOrderItemCount > 0 &&
                                    <>
                                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                            onClick={async (e) => { __check(['CART_API_CALL', 'CART_OPERATION_API_CALL','VIEW_CART_API_CALL']).status ? e.preventDefault() : await updateBackOrderQuantityToCartServer() }}
                                            data-bs-toggle="modal" data-bs-target="#InventoryModal">
                                            {__check(['CART_API_CALL', 'CART_OPERATION_API_CALL','VIEW_CART_API_CALL']).status &&
                                                <i className="fa fa-spinner fa-spin" />
                                            }
                                            {!__check(['CART_API_CALL', 'CART_OPERATION_API_CALL','VIEW_CART_API_CALL']).status &&
                                                <>Yes</>
                                            }
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default InventoryAlertPopup;